export default "__VITE_ASSET__03f09dde__"